import { useState, useEffect } from "react";

const useFragment = () => {
  const [fragment, setFragment] = useState({});

  useEffect(() => {
    // Función para parsear el fragmento de URL
    const parseFragment = (hash) => {
      return hash
        .substring(1) // Eliminar el símbolo "#"
        .split("&") // Separar los diferentes pares clave=valor
        .reduce((acc, pair) => {
          const [key, value] = pair.split("=");
          acc[key] = decodeURIComponent(value); // Decodificar y asignar a un objeto
          return acc;
        }, {});
    };

    // Llamada a la función parseFragment con el fragmento actual de la URL
    const hash = window.location.hash;
    const parsedFragment = parseFragment(hash);
    setFragment(parsedFragment);
  }, []); // El arreglo vacío indica que este efecto se corre sólo al montar el componente

  return fragment;
};

export default useFragment;
